import { RegistrationBizDataModel, RegistrationDataModel } from '../../_interfaces/registration_response.interface';
import { OnboardingSteps } from './onboarding.model';

export class GoToStep {
  static readonly type = '[Onboarding] Go to step';
  constructor(public step: OnboardingSteps) {}
}

export class UpdateShowProgress {
  static readonly type: '[Onboarding] Update showProgress';
  constructor(public showProgress: boolean) {}
}

export class UpdateRegisterStepAndSideGraphic {
  static readonly type = '[Onboarding] Update registration step';
  constructor(
    public step: OnboardingSteps,
    public graphic: string,
  ) {}
}

export class UpdatedSideGraphic {
  static readonly type = '[Onboarding] Update side graphic';
  constructor(public graphic: string) {}
}

export class CreateRegisterDetailsInstance {
  static readonly type = '[Onboarding] create instance of RegisterDetails';
  constructor(public details: RegistrationDataModel) {}
}

export class UpdateRegisterDetails {
  static readonly type = '[Onboarding] update register details';
  constructor(public details: RegistrationDataModel) {}
}

export class ClearRegisterDetails {
  static readonly type = '[Onboarding] clear register details';
}

export class UpdateRegisterBizDetails {
  static readonly type = '[Onboarding] update register business details';
  constructor(public details: RegistrationBizDataModel) {}
}

export class ClearRegisterBusinessDetails {
  static readonly type = '[Onboarding] clear register business details';
}
